import { Collaborator } from './Collaborator';
import { Comment } from './Comment';
import { Company } from './Company';
import { Favorite } from './Favorite';
import { Folder } from './Folder';
import { PipelineColumn } from './PipelineColumn';
import { Team } from './Team';
import { User } from './User';
import { Workspace } from './Workspace';

export enum InvestmentFinancingType {
    EQUITY = 'Equity',
    DEBT = 'Debt',
}

export enum InvestmentMarketType {
    PRIVATE = 'Private',
    PUBLIC = 'Public',
}

export enum InvestmentType {
    TEAM = 'Team',
    SHARED = 'Shared',
    PERSONAL = 'Personal',
    CONNECTED = 'Connected',
}

export enum InvestmentVisibilityType {
    PRIVATE = 'Private',
    LINK = 'Link',
    WORKSPACE = 'Workspace',
}

export interface Investment extends Company {
    id: string;
    user: User;
    workspace: Workspace;
    editedName: string;
    financingType: InvestmentFinancingType | undefined;
    marketType: InvestmentMarketType | undefined;
    type: InvestmentType | undefined;
    visibility: InvestmentVisibilityType | undefined;
    isFavorite: boolean;
    favorites: Favorite[];
    isLocked: boolean;
    isArchived: boolean;
    bannerImage: string;
    folder: Folder;
    team: Team;
    comments: Comment[];
    pipelineColumn: PipelineColumn;
    collaborators: Collaborator[];
    clearbit: any;
    createdAt: Date;
    updatedAt: Date;
    deletedAt?: Date;
}
